import { useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute, useParams } from '@tanstack/react-router'

import { anyOfPermissions } from '@orus.eu/right-access-management'

import { useTRPC } from '../../../../../../client.ts'
import type { SepaCustomerPrefill } from '../../../../../../components/organisms/payment-form/use-sepa-customer-fields.ts'
import { BackofficeContractAddPaymentMethodPage } from '../../../../../../components/pages/backoffice/common/backoffice-contract-page/backoffice-contract-add-payment-method-page.tsx'
import { InviteToLoginPage } from '../../../../../../components/templates/invite-to-login/invite-to-login-page.tsx'
import { useManagedByOrusOnlyPermissions } from '../../../../../../lib/use-managed-by-orus-only-permissions.ts'
import { usePermissions } from '../../../../../../lib/use-permissions.ts'

function RouteComponent(): React.JSX.Element {
  const { subscriptionId } = useParams({ from: '/bo/contracts/$subscriptionId/payment-methods/new' })
  const { hasPermission, type } = usePermissions()
  const { hasManagedByOrusScopedPermission } = useManagedByOrusOnlyPermissions({
    subscriptionId,
    managedByOrusOnlyPermission: 'contract.assignPaymentMethod.managedByOrusOnly',
  })
  const trpc = useTRPC()
  const { data: contract } = useSuspenseQuery(
    type === 'partner'
      ? trpc.contracts.getPartnerContract.queryOptions({ subscriptionId })
      : trpc.contracts.getContract.queryOptions(subscriptionId),
  )

  const canAssign =
    hasPermission(anyOfPermissions('contract.assignPaymentMethod', 'contract.assignPaymentMethod.relatedOnly')) ||
    hasManagedByOrusScopedPermission
  if (!canAssign) return <InviteToLoginPage />

  const dimensions = contract.versions.at(-1)?.dimensions
  const prefill: SepaCustomerPrefill = {
    firstName: dimensions?.firstName ?? undefined,
    lastName: dimensions?.lastName ?? undefined,
    companyName: dimensions?.companyName ?? undefined,
    email: dimensions?.email ?? undefined,
    address: dimensions?.personalAddressStreet ?? undefined,
    postalCode: dimensions?.personalAddressPostCode ?? undefined,
    city: dimensions?.personalAddressCity ?? undefined,
  }

  return (
    <BackofficeContractAddPaymentMethodPage
      subscriptionId={subscriptionId}
      operatingZone={contract.operatingZone}
      prefill={prefill}
    />
  )
}

export const Route = createFileRoute('/bo/contracts/$subscriptionId/payment-methods/new')({
  component: RouteComponent,
})
